import http from "../utils/http-common";

const baseFugitivePath = "api/fugitive";

export const getYear = () => {
  return http.get(`${baseFugitivePath}/year`);
};

export const getOptions = (year: number) => {
  return http.get(`${baseFugitivePath}/options/filter-voc-result/${year}`);
};

// Voc Result
export const getVocResult = (query: string) => {
  return http.get(`${baseFugitivePath}/voc-result/?${query}`);
};

// Monitoring Status
export const getMonitorStatus = (year: number, emission: string) => {
  return http.get(`${baseFugitivePath}/monitor-status/progress/${year}/${emission}`);
};

// Stop Voc
export const getStopVoc = (query: string) => {
  return http.get(`${baseFugitivePath}/stop-voc/?${query}`);
};

// Report Voc Series
export const getOptionsVocSeries = (year: number, query: string) => {
  return http.get(`${baseFugitivePath}/options/filter-voc-series/${year}?${query}`);
};

export const getReportFuelVolume = (query: string) => {
  return http.get(`${baseFugitivePath}/report/voc-series?${query}`);
};

export type UploadReportVocSeriesRow = {
  year: number;
  area: string;
  seriesName: string;
  equipmentType: string;
  service: string;
  totalEquipmentPoint: number;
  measuredEquipment: number;
  exemptEquipment: number;
  exceedingEquipment: number;
  repairedEquipment: number;
  emissionMeasured: number;
  tvocs: number;
  bz: number;
  bd: number;
  vcm: number;
  edc: number;
};

export const uploadReportVocSeries = (rows: UploadReportVocSeriesRow[]) => {
  return http.post(`${baseFugitivePath}/report/voc-series/upload`, { rows });
};

// Report Voc Emission
export const getReportVocEmission = (query: string) => {
  return http.get(`${baseFugitivePath}/report/voc-emission?${query}`);
};

export const submitReportVoc = (data: any) => {
  return http.post(`${baseFugitivePath}/report/voc-emission/approve/submit-report`, data);
};

export const getOptionMonthSubmit = (data: { companyId?: string; year?: number }) => {
  const { companyId, year } = data;
  const query = new URLSearchParams();

  if (year) {
    query.append("year", year.toString());
  }

  if (companyId) {
    query.append("companyId", companyId);
  }

  const url = `${baseFugitivePath}/report/voc-emission/approve?${query.toString()}`;
  return http.get(url);
  // return http.get(`${baseFugitivePath}/report/voc-emission/approve/${year}`);
};

export const updateApproveStep = (data: any) => {
  return http.patch(`${baseFugitivePath}/report/voc-emission/approve/approve-step`, data);
};

export const getInfoStepApprove = (approveId: string) => {
  return http.get(`${baseFugitivePath}/report/voc-emission/approve/info-step/${approveId}`);
};

export const getOptionVocApprove = () => {
  return http.get(`${baseFugitivePath}/report/voc-emission/approve/filter-voc-approve/options`);
};

export const uploadVocResult = (data: any, onUploadProgress: (progressEvent: ProgressEvent) => void) => {
  return http.post(`${baseFugitivePath}/upload/data-from-excel`, data, {
    onUploadProgress,
  });
};
